import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="p-4 bg-white rounded-lg shadow md:flex md:items-center md:justify-between md:p-6 dark:bg-gray-800"
      style={{ bottom: '1rem', position: 'absolute', left: '1rem', right: '1rem' }}
    >
      <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
        © 2022{' '}
        <a href="http://moritz-kaiser.ninja" className="hover:underline" target="_blank" rel="noreferrer">
          Moritz Kaiser
        </a>
        . All Rights Reserved.
      </span>
      <ul className="flex flex-wrap items-center mt-3 text-sm text-gray-500 dark:text-gray-400 sm:mt-0">
        <li>
          <Link to="/impressum" className="mr-4 hover:underline md:mr-6 ">
            Impressum
          </Link>
        </li>
        <li>
          <Link to="/datenschutz" className="mr-4 hover:underline md:mr-6">
            Datenschutzerklärung
          </Link>
        </li>
        <li>
          <a href="http://moritz-kaiser.ninja" className="hover:underline" target="_blank" rel="noreferrer">
            Kontakt
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
